<template>
  <!-- watch 频繁改变 目前写到了add页面里面 
    另一种方式：输入框失去焦点的时候 触发事件传值---发票附件封装-->
  <div>
    <a-table
      :loading="loading"
      :pagination="false"
      :columns="columns"
      :data-source="deathWillHandleListData"
      :row-key="(record) => record.index"
    >
      <div slot="number" slot-scope="text, record, index">
        {{ index + 1 }}
      </div>
      <!-- 办理时间 -->
      <div slot="handleTime" slot-scope="text, record">
        <a-date-picker
          :valueFormat="dayFormat"
          class="w300"
          v-model="record.handleTime"
        />
      </div>
      <!-- 遗嘱办理事项 -->
      <div slot="handleMatter" slot-scope="text, record">
        <a-input
          allowClear
          class="w100"
          placeholder="请输入"
          v-model="record.handleMatter"
        />
      </div>
      <!-- 办理人 -->
      <div slot="handleName" slot-scope="text, record">
        <a-input
          allowClear
          class="w100"
          placeholder="请输入"
          v-model="record.handleName"
        />
      </div>
      <!-- 备注 -->
      <div slot="description" slot-scope="text, record">
        <a-input
          allowClear
          class="w100"
          placeholder="请输入"
          v-model="record.description"
        />
      </div>
      <!-- <div slot="action" slot-scope="text, record">
      </div> -->
    </a-table>
    <div class="accessory-btn">
      <a-button @click="deathWillHandleListData.push({})"
        ><a-icon type="plus" />添加
      </a-button>
    </div>
  </div>
</template>
<script>
const columns = [
  {
    key: 'number',
    scopedSlots: { customRender: 'number' },
    title: '序号',
    align: 'left',
    width: 80
  },
  {
    key: 'handleTime',
    scopedSlots: { customRender: 'handleTime' },
    title: '办理时间',
    align: 'left'
    // width: 100,
  },
  {
    key: 'handleMatter',
    scopedSlots: { customRender: 'handleMatter' },
    title: '遗属待遇办理事项',
    align: 'left'
    // width: 100,
  },

  {
    key: 'handleName',
    scopedSlots: { customRender: 'handleName' },
    title: '办理人',
    align: 'left'
    // width: 100,
  },
  {
    key: 'description',
    scopedSlots: { customRender: 'description' },
    title: '备注',
    align: 'left'
    // width: 100,
  }
]

import { getSuffix, formatDate } from '@/assets/js/auth'
export default {
  components: {},
  props: [],
  data() {
    return {
      columns,
      deathWillHandleListData: [],
      loading: false,
      record: {},
      dayFormat: 'YYYY.MM.DD'
    }
  },
  watch: {
    // 如果表格数据改变 将数组传递给父组件 频繁改变
    deathWillHandleListData: {
      handler(newVal, oldVal) {
        this.$emit('deathWillHandleList', newVal)
      },
      immediate: true,
      deep: true
    }
  },
  mounted() {},
  methods: {
    formatDateIt(data) {
      // 时间格式化
      return formatDate(data)
    }
  }
}
</script>
<style scoped lang="scss">
.accessory-btn {
  margin-top: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>



// WEBPACK FOOTER //
// src/views/PersonnelManagement/TheDead/components/testament-table.vue